import React from 'react';
// import { Card } from './Card';
import { DocumentTextIcon, PlusIcon } from '@heroicons/react/24/outline';

interface EmptyStateProps {
  title: string;
  count?: number;
  message: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  count = 0,
  message,
  icon,
  action,
  className = ''
}) => {
  const defaultIcon = (
    <div className="mx-auto w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center mb-4">
      <DocumentTextIcon className="w-8 h-8 text-blue-600" />
    </div>
  );

  return (
    <div className={`w-full min-h-[400px] flex items-center justify-center ${className}`}>
      <div className="text-center py-12 px-8">
        {icon || defaultIcon}
        <h3 className="text-xl font-bold text-gray-900 mb-3">
          {title} {count > 0 && `(${count})`}
        </h3>
        <p className="text-gray-600 text-lg mb-6 max-w-md mx-auto">
          {message}
        </p>
        {action && (
          <div className="mt-6">
            {action}
          </div>
        )}
        {!action && (
          <div className="mt-6">
            <div className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white text-sm font-medium rounded-lg opacity-50 cursor-not-allowed">
              <PlusIcon className="w-4 h-4 mr-2" />
              No actions available
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
